import { render, staticRenderFns } from "./purchaseProject.vue?vue&type=template&id=02f41e6e&scoped=true"
import script from "./purchaseProject.vue?vue&type=script&lang=js"
export * from "./purchaseProject.vue?vue&type=script&lang=js"
import style0 from "./purchaseProject.vue?vue&type=style&index=0&id=02f41e6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f41e6e",
  null
  
)

export default component.exports